module.exports = __webpack_public_path__ + "img/3-(6).2ab96243.jpg";